import styled from "styled-components"
import Mapbox from "../../../components/Mapbox"
import {useEffect, useState} from "react"
import maplibregl from "maplibre-gl"
import TerminalPointsLayer from "../../../components/Mapbox/components/Layers/TerminalPointsLayer"
import {getTrack} from "../../../library/methods/monitoring"
import PlacesLayer from "../../../components/Mapbox/components/Layers/PlacesLayer"
import TransportTrackLayer from "../../../components/Mapbox/components/Layers/TransportTrackLayer"
import http from "../../../library/network/http"
import {useMap} from "react-map-gl/maplibre"
import {debounce} from "lodash/function"
import Popups from "../../../components/Mapbox/components/Popups"
import sleep from "../../../library/methods/sleep"
import {random} from "lodash/number"

const Map = () => {
	const {"monitoring-main-map": mapRef} = useMap()

	const [routes, setRoutes] = useState([])
	const [activeRoute, setActiveRoute] = useState(null)
	const [track, setTrack] = useState(null)
	const [percent, setPercent] = useState(0)

	const [hover, setHover] = useState(null)

	useEffect(() => {
		(async () => {
			setTrack(null)
			if (activeRoute === null) return

			flyToRoute()

			const data = await getTrack(routes[activeRoute])
			if (data) setTrack(data)
		})()
	}, [activeRoute])


	const load = async () => {
		const result = await http.get('/assets/json/routes3.json')
		if (result.code === 200) {
			const chunkSize = 15
			const data = result.data

			for (let i = 0; i < data.length; i += chunkSize) {
				const chunk = data.slice(i, i + chunkSize)

				setRoutes(routes => [...(routes || []), ...chunk])
				setPercent(((i + chunk.length) / data.length) * 100)
				await sleep(random(10, 200))
			}
		}
	}

	const flyToRoute = () => {
		if (!mapRef || activeRoute === null) return

		const points = [[37.428407, 55.695073]]
		for (const point of routes[activeRoute].points) {
			points.push([point.location[1], point.location[0]])
		}

		if (!points.length) return

		const box = new maplibregl.LngLatBounds(points[0], points[0])
		points.map(bound => {
			box.extend(bound)
		})

		mapRef.fitBounds(box, {
			padding: {
				top: 100,
				bottom: 130,
				left: window.innerWidth / 2 - 635,
				right: window.innerWidth / 2 - 635 + 300
			},
			maxZoom: 11.5,
			speed: 2
		})
	}

	const onClick = e => {
		/*const data = e.target.queryRenderedFeatures([e.point.x, e.point.y])
		const type = data[0]?.layer?.metadata?.type
		const id = data[0]?.properties?.id
		const route_id = data[0]?.properties?.route_id
		if (!route_id) return
		const tmp = [...routes]
		delete tmp.splice(route_id, 1)

		setRoutes(tmp)

		console.log(tmp)*/

		/*const point = store.points.items.find(point => point.id === id)
		if (!point) return
		if (store.terminal.activeRoute !== point.route_id) store.terminal.update('activeRoute', point.route_id)*/
	}


	const onMouseMove = debounce(event => {
		const e = event.target.queryRenderedFeatures([event.point.x, event.point.y])
		const type = e[0]?.layer?.metadata?.type
		const id = e[0]?.properties?.id

		if (type && id !== undefined) {
			switch (type) {
				case "arrow": {
					setHover({
						type: 'arrow',
						data: track[id]
					})
					return
				}
				case "point": {
					setHover({
						type: 'point',
						data: {
							route: routes[e[0]?.properties?.route_id],
							point: routes[e[0]?.properties?.route_id].points[id]
						}
					})
					return
				}
			}
		}

		setHover(null)
	}, [0])


	return (
		<MapWrapper>
			<Mapbox
				id="monitoring-main-map"
				maxZoom={20}
				onLoad={() => mapRef.resize()}
				onClick={onClick}
				initialViewState={{
					longitude: 37.5877594,
					latitude: 55.7421473,
					zoom: 8.2
				}}
				onMouseMove={onMouseMove}
				cursor={hover ? 'pointer' : null}
				style={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0}}
			>
				<TransportTrackLayer track={track} beforeId={null}/>
				<TerminalPointsLayer activeRoute={activeRoute} routes={routes}/>
				<PlacesLayer/>
				<Popups hover={hover}/>
			</Mapbox>
		</MapWrapper>
	)
}

export default Map

const MapWrapper = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    width: 100%;
    min-height: 30vh;
`